jQuery(window).on('load', function() {

	$( "form.search-zip" ).submit(function() {
		const dest_address  = "" + ($("input[name=dest-address]").val()).toString() + "";
		const dest_zipcode  = "" + ($("input[name=dest-zipcode]").val()).toString() + "";
		const dest_town     = "" + ($("input[name=dest-town]").val()).toString() + "";

		const destination = escape(dest_address + "+" + dest_zipcode + "+" + dest_town);

		const start_zipcode = escape("" + ($("input[name=zipcode]").val()).toString() + "");

		if ( start_zipcode !== "" ) {
			window.open("https://www.google.nl/maps/dir/" + start_zipcode + "/" + destination + "/", '_blank');
		}
	});
});
